<template>
  <div :class="componentClassName">
    <a-button
      :inline="true"
      variant="outlined-round"
      color="primary"
      size="small"
      :icon="icon"
      :label="currentLabel"
      @click="handleClick"
    />
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';

export default {
  name: 'a-frequently-used-contact-button',
  components: {
    AButton,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'change', 'click'],
  data() {
    return {
      currentStatus: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-frequently-used-contact-button', this.currentStatus ? 'active' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
    icon() {
      return this.currentStatus ? 'star' : 'star-outline';
    },
    currentLabel() {
      return this.currentStatus ? 'よく使う連絡先解除' : 'よく使う連絡先登録';
    },
  },
  watch: {
    active(val) {
      this.currentStatus = val;
    },
    modelValue(val) {
      this.currentStatus = val;
    },
  },
  mounted() {
    if (this.active) {
      this.currentStatus = this.active;
    }
    if (this.modelValue) {
      this.currentStatus = this.modelValue;
    }
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
      this.currentStatus = !this.currentStatus;
      this.$emit('update:modelValue', this.currentStatus);
      this.$emit('change', this.currentStatus);
    },
  },
};
</script>
